import { render, staticRenderFns } from "./AspectWrapper.vue?vue&type=template&id=36fee829&"
import script from "./AspectWrapper.vue?vue&type=script&lang=js&"
export * from "./AspectWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AspectWrapper.vue?vue&type=style&index=0&id=36fee829&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports